import { useOccContext } from './use-occ-context';
/**
 * Returns the current [[OccAssets]] value.
 */
export const useOccAssets = () => useOccContext().assets;
//# sourceMappingURL=use-occ-assets.js.map